import {StickyTo} from '@gongxigames/framework/core/fragments/react';

export type StickyRichLabelData = RichLabelData & StickyData;

export type RichLabelData = {
    id: string;
    style: string;
    labelContainerName: string;
    hasBackground?: boolean;
};
export type StickyData = {
    sourceContainerName: string;
    stickyPosition?: StickyTo;
};
